export const STATUS_BG_OPACITY: number = 0.18;

export const statusPalette = {
  error: {
    bgBase: 'oklch(56.799% 0.2002 26.406)',
    fg: 'oklch(53.857% 0.1937 26.725)',
  },
  neutral: {
    bgBase: 'oklch(0% 0 0)',
    fg: 'oklch(37.909% 0 89.876)',
  },
  primary: {
    bgBase: 'oklch(48.82% 0.2161 261.374)',
    fg: 'oklch(48.82% 0.2161 261.374)',
  },
  secondary: {
    bgBase: 'oklch(75.875% 0.1243 208.28)',
    fg: 'oklch(61.867% 0.1063 207.967)',
  },
  success: {
    bgBase: 'oklch(67.31% 0.1624 144.208)',
    fg: 'oklch(52.343% 0.1347 144.167)',
  },
  warn: {
    bgBase: 'oklch(67.987% 0.1847 48.146)',
    fg: 'oklch(63.104% 0.197 40.255)',
  },
} as const;

export type StatusTone = keyof typeof statusPalette;
export type StatusPalette = typeof statusPalette;
